module.exports = "input[type=text] {\n  width: 300px; }\n\n.pl-2 {\n  padding-left: 1.5rem !important; }\n\n.ml-1 {\n  margin-left: 1rem !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/documents/filing-structure/filing-structure.component.scss
// module id = ./src/app/administration/documents/filing-structure/filing-structure.component.scss
// module chunks = main